/* eslint-disable jsx-a11y/img-redundant-alt */
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button';
import LocaleSelection from '@/components/LocaleSelection/LocaleSelection';
import { useWebViewRouter } from '@/hooks/useWebViewRouter';
import { WebviewAction } from '@/utils/action';
import useAuth from '@/hooks/useAuth';
import { useSearchParams } from 'react-router-dom';
import { issueAccessToken } from '@/apis/auth';
import { trackEvent } from '@/components/Event/_lib/eventTrack';
import * as amplitude from '@amplitude/analytics-browser';
import { useQuery } from '@tanstack/react-query';
import { getHomeBanners } from '@/apis/main';
import useLocale from '@/hooks/useLocale';
import { LocaleKey } from '@/constants/locale';

export const HomePage = () => {
  const { direct } = useWebViewRouter();
  const { updateToken } = useAuth();
  const [searchParams] = useSearchParams();
  const deviceId = WebviewAction() ?? 'kioskdev';
  const { locale } = useLocale();

  const { data } = useQuery({
    queryFn: () => getHomeBanners(),
    queryKey: ['home-banners']
  });

  const handleClick = async () => {
    try {
      const accessToken = searchParams.get('token');
      if (accessToken) {
        updateToken({ access: accessToken, refresh: '' });
      } else {
        const response = await issueAccessToken({ params: { device_id: deviceId } });
        updateToken({ access: response.access, refresh: response.refresh });
      }
    } catch (error) {
      console.error(error);
    } finally {
      amplitude.setUserId(deviceId);
      trackEvent('Main_Click_Buy_now');
      direct('/promotion');
    }
  };

  return (
    <>
      <div className="w-screen h-screen flex flex-col items-center fixed">
        <div className="w-full h-full flex flex-col items-center justify-center absolute z-10 bg-[#1a2074]">
          <img
            width={1480}
            height={924}
            // quality={100}
            src={`${data?.banners.images[(locale ? locale.toUpperCase() : 'EN') as LocaleKey] ?? '/images/main-home.png'}`}
            alt={'banner-image'}
          />
          <Button className="fixed bottom-[150px] z-10 shadow-lg" data-primary onClick={handleClick}>
            <FormattedMessage id="onboarding_start_btn" defaultMessage="Buy now" />
          </Button>
          <LocaleSelection />
        </div>
      </div>
    </>
  );
};
